import api from "./config";

export const createSignature = (publicId) => {
  return api.post(`/api/images/upload-signature`, { publicId });
};
